<div class="summary-container">
  <div class="questions-status">
    <div class="icon-container">
      <div class="icon-container__inner">
        <img
          class="icon-container__img"
          src="assets/icons/show_chart.svg"
          alt=""
          srcset=""
        />
      </div>
    </div>
    <div class="questions-status-container">
      <div class="questions-answered p-style">
        <div>
          {{ correctAnswers }}
        </div>
        @if (!isFlashCard) {
        <div>
          {{ 'quiz.summary.rightAnsweredCount' | translate }}
        </div>
        } @if (isFlashCard) {
        <div>
          {{ 'flashCardStack.answerKnown' | translate }}
        </div>
        }
      </div>
      <div class="wrong-questions p-style">
        <div>
          {{ inCorrectAnswers }}
        </div>
        @if (!isFlashCard) {
        <div>
          {{ 'quiz.summary.wrongAnsweredCount' | translate }}
        </div>
        } @if (isFlashCard) {
        <div>
          {{ 'flashCardStack.answernotKnown' | translate }}
        </div>
        }
      </div>
      <div class="not-attended-questions p-style">
        <div>
          {{ totalQuestions - (correctAnswers + inCorrectAnswers) }}
        </div>
        <div>{{ 'quiz.summary.notAnsweredCount' | translate }}</div>
      </div>
    </div>
  </div>
</div>
